import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPalette = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M16.0003 29.3332C12.4641 29.3332 9.07272 27.9284 6.57223 25.4279C4.07175 22.9274 2.66699 19.5361 2.66699 15.9998C2.66699 12.4636 4.07175 9.07223 6.57223 6.57175C9.07272 4.07126 12.4641 2.6665 16.0003 2.6665C19.5365 2.6665 22.9279 3.93079 25.4284 6.18122C27.9289 8.43166 29.3337 11.4839 29.3337 14.6665C29.3337 16.4346 28.6313 18.1303 27.381 19.3805C26.1308 20.6308 24.4351 21.3332 22.667 21.3332H19.667C19.2337 21.3332 18.8089 21.4538 18.4403 21.6816C18.0717 21.9095 17.7738 22.2354 17.58 22.623C17.3862 23.0106 17.3042 23.4445 17.3431 23.876C17.382 24.3076 17.5403 24.7198 17.8003 25.0665L18.2003 25.5998C18.4603 25.9465 18.6186 26.3587 18.6576 26.7903C18.6965 27.2219 18.6144 27.6558 18.4207 28.0433C18.2269 28.4309 17.929 28.7569 17.5604 28.9847C17.1918 29.2125 16.767 29.3332 16.3337 29.3332H16.0003Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M17.9997 9.33333C18.3679 9.33333 18.6663 9.03486 18.6663 8.66667C18.6663 8.29848 18.3679 8 17.9997 8C17.6315 8 17.333 8.29848 17.333 8.66667C17.333 9.03486 17.6315 9.33333 17.9997 9.33333Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_3",
			d: "M23.3337 14.6668C23.7018 14.6668 24.0003 14.3684 24.0003 14.0002C24.0003 13.632 23.7018 13.3335 23.3337 13.3335C22.9655 13.3335 22.667 13.632 22.667 14.0002C22.667 14.3684 22.9655 14.6668 23.3337 14.6668Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_4",
			d: "M8.66667 17.3333C9.03486 17.3333 9.33333 17.0349 9.33333 16.6667C9.33333 16.2985 9.03486 16 8.66667 16C8.29848 16 8 16.2985 8 16.6667C8 17.0349 8.29848 17.3333 8.66667 17.3333Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector_5",
			d: "M11.3337 10.6668C11.7018 10.6668 12.0003 10.3684 12.0003 10.0002C12.0003 9.63197 11.7018 9.3335 11.3337 9.3335C10.9655 9.3335 10.667 9.63197 10.667 10.0002C10.667 10.3684 10.9655 10.6668 11.3337 10.6668Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPalette;
